/**
 * Design Tokens for Sondely
 *
 * Generated by Ideaplaces Style Guide Generator
 * Palette: Gentle Glow
 *
 * A serene and focused color palette for a data-driven platform in well-being.
 */

export const COLORS = {
  // Primary
  primary: '#4F46E5',
  primaryLight: '#7C9BFF',
  primaryDark: '#3B3D93',

  // Secondary
  secondary: '#6EE7B7',
  secondaryLight: '#96F0D4',
  secondaryDark: '#3FBA8E',

  // Accent
  accent: '#FBBF24',

  // Background & Surface
  background: '#FAF9F7',
  backgroundAlt: '#F9F8F6',
  surface: '#FFFFFF',

  // Foreground
  foreground: '#1F2937',
  foregroundMuted: '#6B7280',

  // Borders
  border: '#D1D5DB',
  borderLight: '#E5E7EB',

  // Semantic
  success: '#22C55E',
  warning: '#FBBF24',
  error: '#EF4444',
  info: '#3B82F6',
} as const

export const TYPOGRAPHY = {
  fontFamily: 'Inter, sans-serif',
  fontFamilyHeading: 'DM Sans, sans-serif',
  fontFamilyMono: 'Courier New, monospace',
  fontWeightBody: 400,
  fontWeightHeading: 700,
  lineHeightBody: 1.6,
  lineHeightHeading: 1.2,
  scale: [12, 14, 16, 18, 20, 24, 30, 36, 48, 60],
} as const

export const SPACING = {
  baseUnit: 8,
  scale: [4, 8, 12, 16, 24, 32, 48, 64, 96],
  borderRadius: '8px',
  iconStyle: 'outlined',
} as const

export const SHADOWS = {
  sm: '0 1px 3px rgba(0, 0, 0, 0.08)',
  md: '0 4px 6px rgba(0, 0, 0, 0.1)',
  lg: '0 10px 15px rgba(0, 0, 0, 0.1)',
  xl: '0 20px 25px rgba(0, 0, 0, 0.15)',
} as const

export type ColorName = keyof typeof COLORS
